import React, { Component } from 'react';
//Checked
export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Enteral Info</h3>
				<hr />
				<p>Mode of Administration</p>
				<div className="toggle">
					<div className={this.props.data.ModeOfAdmin == 'T' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('ModeOfAdmin', 'T') }}>Feeding Tube</div>
					<div className={this.props.data.ModeOfAdmin == 'O' ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('ModeOfAdmin', 'O') }}>Oral</div>
				</div>
				{(this.props.data.ModeOfAdmin == 'T') ? <p>Please note: The Diagnosis Code must be written on the script by the provider.</p> : ''}

				<p>Is the Enteral formula being prescribed for an Inborn-Metabolic disease?</p>
				<div className="toggle">
					<div className={this.props.data.InbornMetabolic == true ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('InbornMetabolic', true) }}>Yes</div>
					<div className={this.props.data.InbornMetabolic == false ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('InbornMetabolic', false) }}>No</div>
				</div>

				<div className="button" onClick={() => this.props.navigate(this.props.data.InbornMetabolic ? 'R4' : this.props.data.ModeOfAdmin == 'T' ? 'R8' : new Date().getTime() - new Date(this.props.data.DOB).getTime() < 31536000000 ? 'R3' : 'R8')}>Continue</div>
			</div>
		);
	}
}


